import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

const Button = styled('div', {
  width: '75px',
  padding: '6px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  borderWidth: '2.5px',
  border: '2px solid $primary1',
  background: '$primary1',
  borderStyle: 'solid',
  borderRadius: '23px',
  marginTop: '10px',
  marginBottom: '20px',
  alignItems: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

const ButtonText = styled('span', {
  color: '$white',
  fontWeight: 'bold',
  fontSize: '16px',
});

const ModalFooter = styled('span', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
});

const HeaderText = styled('h3', {
  fontWeight: 600,
  fontSize: '24px',
  width: '100%',
  marginTop: '10px',
  marginBottom: '8px',
  color: '$primary1',
  fontFamily: '$heading',
});

const SubHeaderText = styled('p', {
  fontSize: '16px',
  fontWeight: 500,
  marginBottom: '20px',
  width: '367px',
  lineHeight: '22px',
  color: '$gray8',
  fontFamily: '$primary',
});

const HelpText = styled('p', {
  fontSize: '14px',
  fontWeight: 500,
  marginTop: '10px',
  lineHeight: '19px',
  textAlign: 'left',
  color: '$gray8',
  fontFamily: '$primary',
});

const ContentWrapper = styled('div', {
  width: '100%',
  paddingLeft: '50px',
});

const ArrowWrapper = styled('div', {
  textAlign: 'right',
});

const TableWrapper = styled('div', {
  padding: '10px',
  border: '1px solid #979797',
});

const PaymentNumberLabel = styled('span', {
  fontSize: '16px',
  fontWeight: 'bold',
  lineHeight: '19px',
});

const RegularNumberFormat = styled('span', {
  fontSize: '16px',
  fontWeight: 'bold',
  lineHeight: '19px',
  marginLeft: '10px',
});

const ShortNumberFormat = styled('span', {
  fontSize: '16px',
  fontWeight: 'bold',
  lineHeight: '19px',
  marginLeft: '14px',
});

const BorderWrapper = styled('div', {
  marginTop: '-12px',
});

const LabelWrapper = styled('div', {
  marginTop: '-12px',
});

const Space = styled('div', {
  width: '1px',
  display: 'inline-block',
  marginLeft: '68px',
});

const ThreeBorders = styled('div', {
  height: '8px',
  marginLeft: '5px',
  display: 'inline-block',
  borderBottom: ' 3px solid $primary1',
  borderLeft: '3px solid $primary1',
  borderRight: '3px solid $primary1',
});

const RefNumHelpLabel = styled('div', {
  fontSize: '10px',
  lineHeight: '10px',
  marginLeft: '5px',
  fontWeight: 600,
  marginTop: '10px',
  display: 'inline-block',
  fontFamily: '$primary',
  color: '$primary1',
});

const RegularLabel = styled(RefNumHelpLabel, {
  width: '110px',
});

const ShortLabel = styled(RefNumHelpLabel, {
  width: '100px',
});

const LongLabel = styled(RefNumHelpLabel, {
  width: '200px',
});

const RegularBorder = styled(ThreeBorders, {
  width: '110px',
});

const ShortBorder = styled(ThreeBorders, {
  marginLeft: '4px',
  width: '100px',
});

const LongBorder = styled(ThreeBorders, {
  width: '200px',
});

const DataLabel = styled('span', {
  textAlign: 'right',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '22px',
  display: 'block',
});

const DataValue = styled('span', {
  textAlign: 'left',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '22px',
  display: 'block',
});

const PaymentNumberWrapper = styled(Flex, {
  width: '299px',
  marginLeft: '-10px',
  backgroundColor: '$tint2',
});

const IconRightArrow = styled(IconSymbol, {
  marginTop: '95px',
});

export const PaymentInfoHelpModal = ({ show, onClose }) => {
  return (
    <React.Fragment>
      <Modal isOpen={show} showCloseButton onClose={onClose}>
        <Modal.Section>
          <HeaderText>Payment Reference Number Location</HeaderText>
          <Flex>
            <div style={{ width: '50%' }}>
              <SubHeaderText>
                This data can be found at the top of a Provider Remittance
                Advice (PRA)
              </SubHeaderText>
              <Flex>
                <div style={{ width: '20%' }}>
                  <ArrowWrapper>
                    <IconRightArrow size={32} color="$primary1" />
                  </ArrowWrapper>
                </div>
                <div style={{ width: '80%' }}>
                  <TableWrapper>
                    <Flex>
                      <div style={{ width: '50%' }}>
                        <DataLabel>Payment Date:</DataLabel>
                      </div>
                      <div style={{ width: '50%' }}>
                        <DataValue>&nbsp;MM/DD/YYYY</DataValue>
                      </div>{' '}
                    </Flex>{' '}
                    <Flex>
                      <div style={{ width: '50%' }}>
                        <DataLabel>TIN:</DataLabel>
                      </div>
                      <div style={{ width: '50%' }}>
                        <DataValue>&nbsp;#######</DataValue>
                      </div>{' '}
                    </Flex>{' '}
                    <Flex>
                      <div style={{ width: '50%' }}>
                        <DataLabel>NPI:</DataLabel>
                      </div>
                      <div style={{ width: '50%' }}>
                        <DataValue>&nbsp;#######</DataValue>
                      </div>{' '}
                    </Flex>{' '}
                    <Flex>
                      <div style={{ width: '50%' }}>
                        <DataLabel>Payee Name:</DataLabel>
                      </div>
                      <div style={{ width: '50%' }}>
                        <DataValue>&nbsp;Example Hospital</DataValue>
                      </div>{' '}
                    </Flex>{' '}
                    <PaymentNumberWrapper>
                      <div>
                        <Flex>
                          <div>
                            <DataLabel>Payment Number:</DataLabel>
                          </div>
                          <div>
                            <DataValue>&nbsp;#######</DataValue>
                          </div>{' '}
                        </Flex>
                      </div>
                    </PaymentNumberWrapper>{' '}
                    <Flex>
                      <div style={{ width: '50%' }}>
                        <DataLabel>Payment Amount:</DataLabel>
                      </div>
                      <div style={{ width: '50%' }}>
                        <DataValue>&nbsp;$##.##</DataValue>
                      </div>{' '}
                    </Flex>{' '}
                    <Flex>
                      <div style={{ width: '50%' }}>
                        <DataLabel>Group Number:</DataLabel>
                      </div>
                      <div style={{ width: '50%' }}>
                        <DataValue>&nbsp;#######</DataValue>
                      </div>{' '}
                    </Flex>{' '}
                    <Flex>
                      <div style={{ width: '50%' }}>
                        <DataLabel>Group Name:</DataLabel>
                      </div>
                      <div style={{ width: '50%' }}>
                        <DataValue>&nbsp;Example Hospital</DataValue>
                      </div>
                    </Flex>
                  </TableWrapper>
                </div>
              </Flex>
            </div>
            <div style={{ width: '50%' }}>
              <ContentWrapper>
                <HelpText>
                  If the payment number on your PRA has two strings separated by
                  a space, then the 1st string should be entered as the series
                  designator code and 2nd string should be entered as the
                  payment reference number.{' '}
                </HelpText>
                <PaymentNumberLabel>Payment Number:</PaymentNumberLabel>
                <RegularNumberFormat>#########</RegularNumberFormat>
                <ShortNumberFormat>########</ShortNumberFormat>
                <BorderWrapper>
                  <Space />
                  <RegularBorder />
                  <ShortBorder />
                </BorderWrapper>
                <LabelWrapper>
                  <Space />
                  <RegularLabel>Series Designator Code</RegularLabel>
                  <ShortLabel>Payment Reference Number</ShortLabel>
                </LabelWrapper>
                <HelpText>
                  If the payment number on your PRA is one string (no space),
                  then the entire string should be entered as the payment
                  reference number with no series designator code.
                </HelpText>
                <PaymentNumberLabel>Payment Number:</PaymentNumberLabel>
                <RegularNumberFormat>#################</RegularNumberFormat>
                <BorderWrapper>
                  <Space />
                  <LongBorder />
                </BorderWrapper>
                <LabelWrapper>
                  <Space />
                  <LongLabel>Payment Reference Number</LongLabel>
                </LabelWrapper>
              </ContentWrapper>
            </div>
          </Flex>
        </Modal.Section>
        <ModalFooter>
          <Button onClick={onClose}>
            <ButtonText>OK</ButtonText>
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

PaymentInfoHelpModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
